import { create } from 'zustand'

interface State {
  currentCount: number
}

interface Actions {
  update: (count?: number | undefined) => void
}

export const useCountStore = create<State & Actions>((set) => ({
  currentCount: 0,
  update: (count) =>
    set((state) => (count !== undefined ? { currentCount: count } : state)),
}))
